export default "__VITE_ASSET__jSd8Kh_T__"